import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
	width: 100%;
	position: static;
	z-index: 999;
	left: 0;
	top: 0;
	background-color: #fff;
	display: flex;
	justify-content: center;

	.image {
		width: 25%;
	}

	.close {
		position: absolute;
		top: 0;
		right: 0;
		cursor: pointer;

		.close-icon {
			width: 2em;
			filter: invert(25%) sepia(68%) saturate(2482%) hue-rotate(336deg)
				brightness(94%) contrast(84%);
		}

		&:hover {
			opacity: 0.8;
		}
	}

	@media all and (max-width: ${vars.mobileL}) {
		justify-content: flex-start;

		.image {
			width: 100%;
			margin: 0;
			padding: 0 2.8em 0 0;
		}

		.close {
			top: 51%;
			right: 0.4em;
			transform: translateY(-50%);
			.close-icon {
				width: 2.5em;
			}
		}
	}
`;